import { render, staticRenderFns } from "./PortFuelCharacteristics.vue?vue&type=template&id=054c877e&scoped=true"
import script from "./PortFuelCharacteristics.vue?vue&type=script&lang=js"
export * from "./PortFuelCharacteristics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c877e",
  null
  
)

export default component.exports